<script setup>
import { useAttrs } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const attrs = useAttrs();
const globalConfig = useMapGetter('globalConfig/get');
</script>

<template>
  <img
    v-if="globalConfig.logoThumbnail"
    v-bind="attrs"
    :src="globalConfig.logoThumbnail"
  />
  <svg
    v-else
    v-once
    v-bind="attrs"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient id="fluxi-grad" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stop-color="#00AEEF" />
        <stop offset="100%" stop-color="#35C28C" />
      </linearGradient>
    </defs>
    <rect width="16" height="16" rx="4" fill="url(#fluxi-grad)" />
    <path d="M5 4H11V6H7V8H10V10H7V13H5V4Z" fill="white" />
  </svg>
</template>
